import React, { Component } from 'react';

import { AppHeaderStyles, AppIcon, LeftAppIcon, MidSpace, RightAppMenu } from './AppHeaderStyles';

import { MYBIZ_DEFAULT_LOGOS, MYBIZ_LOGO_IMAGES, PATHS } from 'AppConstants';
export default class AppHeader extends Component {

    constructor (props) {
        super(props);
    }

    goToHome = (event) => {
        event.preventDefault();
        window.location = PATHS.MYBIZ_URL
    }

    render () {
        return (
            <AppHeaderStyles>
                <LeftAppIcon>
                    <AppIcon {...(MYBIZ_LOGO_IMAGES.LOGO || MYBIZ_DEFAULT_LOGOS.LOGO)} onClick={this.goToHome}/>
                </LeftAppIcon>
                <MidSpace/>
                <RightAppMenu>
                    {this.props.children}
                </RightAppMenu>
            </AppHeaderStyles>
        );
    }
}
